<template>
  <div class="flex flex-col items-start">
    <i18n-t
      scope="global"
      keypath="modules.order.priceType.marketPrice.description"
      tag="span"
      class="text-c2 font-normal"
    >
      <template #bestPriceAvailableOnOrders>
        <NText weight="bold" variant="caption2" class="text-neutral-secondary">
          {{
            t('modules.order.priceType.marketPrice.bestPriceAvailableOnOrders')
          }}
        </NText>
      </template>
    </i18n-t>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
